// src/api/client.js
import axios from 'axios';

const LOCAL_IP_URL = 'http://10.0.0.191.nip.io:8080';
const BASE_URL = process.env.REACT_APP_API_BASE_URL || LOCAL_IP_URL || 'http://localhost:8080';

const apiClient = axios.create({
  baseURL: BASE_URL,
  withCredentials: true,
});

// One interceptor to rule them all
apiClient.interceptors.request.use(config => {
  const token = localStorage.getItem('X-Auth-Token');
  if (token) {
    config.headers['X-Auth-Token'] = token;
  }
  return config;
});

export default apiClient;